import type { ReferrerAuthEvent } from "@redotech/admin-sdk/rpc/schema/referrers/shared";
import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { memo } from "react";

import { formatLastActivity } from "../../onboardings/common/utils";

interface ReferrerAuthEventsListProps {
  events: ReferrerAuthEvent[];
}

const eventTypeLabels: Record<string, string> = {
  magic_link_sent: "Magic link sent",
  magic_link_verified: "Signed in via magic link",
  magic_link_invalid: "Invalid magic link attempted",
  magic_link_expired: "Expired magic link attempted",
  magic_link_already_used: "Magic link reused",
  login_success: "Login succeeded",
  login_failure: "Login failed",
  logout: "Logged out",
  session_refreshed: "Session refreshed",
};

export const ReferrerAuthEventsList = memo(function ReferrerAuthEventsList({
  events,
}: ReferrerAuthEventsListProps) {
  if (events.length === 0) {
    return (
      <Flex align="center" justify="center" p="3xl">
        <Text fontSize="md">No auth events yet.</Text>
      </Flex>
    );
  }
  return (
    <Flex dir="column" gap="sm" p="lg">
      {events.map((event) => (
        <Flex
          align="center"
          dir="row"
          gap="md"
          justify="space-between"
          key={event.id}
          py="xs"
        >
          <Flex dir="column" gap="xs">
            <Text fontSize="sm" fontWeight="semibold">
              {eventTypeLabels[event.eventType] ?? event.eventType}
            </Text>
            <Text fontSize="xs" textColor="secondary">
              {event.ipAddress ?? "no ip"} ·{" "}
              {event.userAgent ?? "no user-agent"}
            </Text>
          </Flex>
          <Text fontSize="xs" textColor="secondary">
            {formatLastActivity(new Date(event.occurredAt))}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
});
